<div class="card-component-wrap" [ngClass]="{ opened: open | async }">
  <div *ngIf="mobileModal && modalTitle" class="d-not-phone-none phone-modal-header with-title">
    <button class="no-style back-btn" (click)="close()">
      <mat-icon [svgIcon]="'prev'" class="square-icon back-icon"></mat-icon>
    </button>
    <div *ngIf="modalTitle" class="separator"></div>
    {{ modalTitle }}
  </div>

  <mat-card class="mb-0">
    <mat-card-content>
      <div *ngIf="mobileModal" class="d-not-phone-none phone-modal-header mobile-modal-header-link-wrapper">
        
        <ng-content select="[header-link]" ></ng-content>
      </div>

      <ng-content></ng-content>
    </mat-card-content>
  </mat-card>
</div>
